import React from "react";

import TermsOfUse from "../components/auth/TermsOfUse";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Register = () => {
  return (
    <div>
      <Header />
      <TermsOfUse />
      <Footer />
    </div>
  );
};

export default Register;
